// Decks API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createDecksApi(client) {
  return {
    async getDecks(options = {}) {
      const params = new URLSearchParams()
      if (options.user) params.append('user', 'true')
      if (options.id) params.append('id', options.id)
      if (options.userId) params.append('userId', options.userId)
  
      const result = await this.call(`/decks?${params}`)
      return { data: result.data, error: null }
    },

    async createDeck(deckData, userDeckData = null) {
      const result = await this.call('/decks', {
        method: 'POST',
        body: JSON.stringify({ deck: deckData, userDeck: userDeckData })
      })
      return { data: result.data, error: null }
    },

    async updateDeck(id, updates) {
      const result = await this.call(`/decks?id=${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates)
      })
      return { data: result.data, error: null }
    },

    async getUserDeck(userDeckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getUserDeck', userDeckId })
      })
      return { data: result.data, error: null }
    },

    async getUserDeckByDeckId(deckId, userId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getUserDeckByDeckId', deckId, userId })
      })
      return { data: result.data, error: null }
    },

    async updateUserDeck(userDeckId, updates) {
      try {
        const result = await this.call('/study', {
          method: 'POST',
          body: JSON.stringify({ action: 'updateUserDeck', userDeckId, updates })
        })
        return { data: result.data, error: result.error || null }
      } catch (err) {
        return { data: null, error: err.message }
      }
    },

    async getSubscriptions(userId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getUserSubscriptions', userId })
      })
      return { data: result.data, error: null }
    },

    async getDeckSubscriptions(deckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getDeckSubscriptions', deckId })
      })
      return { data: result.data, error: null }
    },

    async deleteUserDeck(userDeckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'deleteUserDeck', deckId: userDeckId })
      })
      return { error: null }
    },

    async deleteUserDecksByDeck(deckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'deleteUserDecksByDeck', deckId })
      })
      return { error: null }
    },

    async getOtherSubscriptions(deckId, userId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'getOtherSubscriptions', deckId, userId })
      })
      return { data: result.data, error: null }
    },

    async deleteDeck(deckId) {
      const result = await this.call('/study', {
        method: 'POST',
        body: JSON.stringify({ action: 'deleteDeck', deckId })
      })
      return { error: null }
    },

    async getPresetDecks(page = 1, limit = 12, filters = {}) {
      const params = new URLSearchParams({
        preset: 'true',
        page: page.toString(),
        limit: limit.toString()
      })
  
      if (filters.search) params.append('search', filters.search)
      if (filters.difficulty && filters.difficulty !== 'all') params.append('difficulty', filters.difficulty)
      if (filters.language && filters.language !== 'all') params.append('language', filters.language)
  
      const result = await this.call(`/decks?${params}`)
      return { data: result.data, total: result.total, page: result.page, limit: result.limit, error: null }
    },

    async getUserActiveDecks(userId) {
      const result = await this.call(`/decks?user=true&userId=${userId}`)
      return { data: result.data, error: null }
    },

    async getUserCreatedDecks(userId) {
      const result = await this.call(`/decks?user=true&created=true&userId=${userId}`)
      return { data: result.data, error: null }
    },

    async subscribeToDeck(deckId, userId) {
      const result = await this.call('/decks', {
        method: 'POST',
        body: JSON.stringify({ action: 'subscribe', deckId, userId })
      })
      return { data: result.data, error: null }
    },

    async getDeck(id) {
      const result = await this.call(`/decks?id=${id}`, {
        method: 'GET'
      })
      return { data: result.data, error: null }
    }
  }
}
